export const companyFactory = {
  getCompanyAdminStatus: status => {
    return {
      admin: { isManaged: status },
    };
  },

  getCompanyNotFound: () => {
    return {
      value: 'uid-not-found',
      company: 'uid-not-found',
      uid: 'uid-not-found',
    };
  },
};
